import React from "react";
import styled from "@emotion/styled";
import { SVGComponent } from "@typings/svg-component";
import { stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import { GetStartedStepStatus } from "@domain/get-started/get-started";
import { CardIllustration } from "@ui/pages/get-started/components/card-illustration";
import { StepIcon } from "@ui/pages/get-started/components/step-icon";

interface OnboardingCardProps {
	status: GetStartedStepStatus;
	icon: SVGComponent;
	mainHeadline: string;
	secondaryHeadline: string;
	description: string;
	bottom: React.ReactElement;
	className?: string;
}

export const OnboardingCard: React.FC<OnboardingCardProps> = ({
	status,
	icon,
	mainHeadline,
	secondaryHeadline,
	description,
	bottom,
	className,
}) => (
	<Container className={className}>
		<CardIllustrationContainer>
			<CardIllustration icon={icon} />
		</CardIllustrationContainer>
		<Card className="p-card">
			<Top>
				<StepIcon status={status} />
				<MainHeadline status={status}>{mainHeadline}</MainHeadline>
				<SecondaryHeadline status={status} className="p-size-l-bold">
					{secondaryHeadline}
				</SecondaryHeadline>
				<Description status={status} className="p-size-s">
					{description}
				</Description>
			</Top>
			<div>{bottom}</div>
		</Card>
	</Container>
);

const Container = styled.div`
	${stack()};
	min-width: 300px;
	width: 320px;
`;

const CardIllustrationContainer = styled.div`
	align-self: center;
	height: 96px;
	overflow: visible;
`;

const Card = styled.div`
	${stack(undefined, "spacebetween")};
	flex: 1;
	align-self: stretch;
	padding: 56px 24px 24px 24px;
`;

const Top = styled.div`
	${stack(16)};
`;

const MainHeadline = styled.h3<{ status: GetStartedStepStatus }>`
	color: ${({ status }) => (status === GetStartedStepStatus.Disabled ? colors.grey50 : colors.onboardingPrimary)};
`;

const SecondaryHeadline = styled.div<{ status: GetStartedStepStatus }>`
	${({ status }) => status === GetStartedStepStatus.Disabled && `color: ${colors.grey50};`}
`;

const Description = styled.div<{ status: GetStartedStepStatus }>`
	${({ status }) => status === GetStartedStepStatus.Disabled && `color: ${colors.grey50};`}
`;
